import { css } from '@emotion/react';
import { ReactNode } from 'react';
import { theme } from 'styles/theme';

export const SummaryHeading = ({ children }: { children: ReactNode }) => {
	return (
		<div
			css={css`
				color: ${theme.color.primary['400']};
				margin: 12px 0;
			`}
		>
			{children}
		</div>
	);
};
